import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, vModelText as _vModelText, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/audio/text-click.ogg'
import _imports_1 from '@/assets/audio/text-click.mp3'
import _imports_2 from '@/assets/audio/quest-click.ogg'
import _imports_3 from '@/assets/audio/quest-click.mp3'
import _imports_4 from '@/assets/images/edit.svg'


const _withScopeId = n => (_pushScopeId("data-v-97dbca4e"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  ref: "audioCancelConfirm",
  preload: "auto"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("source", {
  src: _imports_0,
  type: "audio/ogg"
}, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("source", {
  src: _imports_1,
  type: "audio/mp3"
}, null, -1))
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]
const _hoisted_5 = {
  ref: "audioQuestClick",
  preload: "auto"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("source", {
  src: _imports_2,
  type: "audio/ogg"
}, null, -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("source", {
  src: _imports_3,
  type: "audio/mp3"
}, null, -1))
const _hoisted_8 = [
  _hoisted_6,
  _hoisted_7
]
const _hoisted_9 = { class: "header" }
const _hoisted_10 = { class: "body" }
const _hoisted_11 = { class: "quest-selector" }
const _hoisted_12 = { class: "quest-selector-list" }
const _hoisted_13 = {
  key: 0,
  class: "quest-header"
}
const _hoisted_14 = ["onClick"]
const _hoisted_15 = { class: "quest-details" }
const _hoisted_16 = { class: "flex-row" }
const _hoisted_17 = {
  key: 0,
  class: "quest-desc-name"
}
const _hoisted_18 = { class: "quest-description" }
const _hoisted_19 = { key: 0 }
const _hoisted_20 = { class: "quest-rewards" }
const _hoisted_21 = { class: "quest-reward-icons" }
const _hoisted_22 = ["onClick"]
const _hoisted_23 = ["src"]
const _hoisted_24 = { class: "quantity-text" }
const _hoisted_25 = { class: "flex-end save-buttons" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_item_description_overlay = _resolveComponent("item-description-overlay")!
  const _component_item_obtain_overlay = _resolveComponent("item-obtain-overlay")!
  const _component_close_button = _resolveComponent("close-button")!
  const _component_cancel_confirm_button = _resolveComponent("cancel-confirm-button")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.itemDescriptionId)
      ? (_openBlock(), _createBlock(_component_item_description_overlay, {
          key: 0,
          item: _ctx.itemDescription,
          onExit: _cache[0] || (_cache[0] = ($event: any) => (_ctx.itemDescriptionId = ''))
        }, null, 8, ["item"]))
      : _createCommentVNode("", true),
    (_ctx.obtainScreenRewards.length > 0)
      ? (_openBlock(), _createBlock(_component_item_obtain_overlay, {
          key: 1,
          "obtained-items": _ctx.obtainScreenRewards,
          onExit: _cache[1] || (_cache[1] = ($event: any) => (_ctx.obtainScreenRewards = []))
        }, null, 8, ["obtained-items"]))
      : _createCommentVNode("", true),
    _createElementVNode("audio", _hoisted_1, _hoisted_4, 512),
    _createElementVNode("audio", _hoisted_5, _hoisted_8, 512),
    _createElementVNode("div", {
      class: _normalizeClass({ main: true, 'exit-main': !_ctx.active }),
      onAnimationend: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.exit && _ctx.exit(...args)))
    }, [
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("p", null, _toDisplayString(_ctx.currentTab), 1),
        _createVNode(_component_close_button, { onClicked: _ctx.exitAnimation }, null, 8, ["onClicked"])
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.formattedQuests, (category, _) => {
              return (_openBlock(), _createElementBlock(_Fragment, { key: _ }, [
                (_ctx.currentTab === 'All Quests' && category.quests.length > 0)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_13, _toDisplayString(category.name), 1))
                  : _createCommentVNode("", true),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(category.quests, (quest) => {
                  return (_openBlock(), _createElementBlock(_Fragment, {
                    key: quest.id
                  }, [
                    (
                  _ctx.currentTab === 'All Quests' || _ctx.currentTab === category.name
                )
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 0,
                          class: _normalizeClass({
                  'quest-box': true,
                  'quest-box-active': _ctx.currentQuest.id === quest.id,
                  'quest-box-faded': quest.complete,
                }),
                          onClick: ($event: any) => (_ctx.setCurrentQuest(quest))
                        }, [
                          _createElementVNode("div", null, _toDisplayString(quest.name), 1)
                        ], 10, _hoisted_14))
                      : _createCommentVNode("", true)
                  ], 64))
                }), 128))
              ], 64))
            }), 128))
          ]),
          _createElementVNode("div", null, [
            (!_ctx.editMode)
              ? (_openBlock(), _createBlock(_component_cancel_confirm_button, {
                  key: 0,
                  text: "New",
                  invert: "",
                  onPressed: _ctx.newQuest
                }, null, 8, ["onPressed"]))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("div", _hoisted_15, [
          _createElementVNode("div", _hoisted_16, [
            (!_ctx.editMode)
              ? (_openBlock(), _createElementBlock("p", _hoisted_17, _toDisplayString(_ctx.currentQuest.name), 1))
              : _withDirectives((_openBlock(), _createElementBlock("input", {
                  key: 1,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.currentQuest.name) = $event)),
                  type: "text",
                  class: "quest-desc-name"
                }, null, 512)), [
                  [_vModelText, _ctx.currentQuest.name]
                ]),
            (!_ctx.currentQuest.uneditable)
              ? (_openBlock(), _createElementBlock("img", {
                  key: 2,
                  class: "ui-icon",
                  src: _imports_4,
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.editMode = !_ctx.editMode))
                }))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_18, [
            (!_ctx.editMode)
              ? (_openBlock(), _createElementBlock("p", _hoisted_19, _toDisplayString(_ctx.currentQuest.description), 1))
              : _withDirectives((_openBlock(), _createElementBlock("textarea", {
                  key: 1,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.currentQuest.description) = $event)),
                  class: "quest-description"
                }, null, 512)), [
                  [_vModelText, _ctx.currentQuest.description]
                ])
          ]),
          _createElementVNode("div", _hoisted_20, [
            _createElementVNode("p", {
              class: _normalizeClass({ 'quest-header': true, 'quest-header-white': _ctx.editMode })
            }, " Quest Chain Rewards: ", 2),
            _createElementVNode("div", _hoisted_21, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.currentQuest.rewards, (i, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: index,
                  class: _normalizeClass([
                'reward-icon-graphics',
                [0, 'gray', 'green', 'blue', 'purple', 'orange'][
                  _ctx.idToItem(i.id).rarity
                ],
              ]),
                  onClick: ($event: any) => (_ctx.itemDescriptionId = i.id)
                }, [
                  _createElementVNode("img", {
                    src: require(`@/assets/images/${i.id}.webp`),
                    class: "icon-img"
                  }, null, 8, _hoisted_23),
                  _createElementVNode("div", _hoisted_24, _toDisplayString(i.quantity), 1)
                ], 10, _hoisted_22))
              }), 128))
            ])
          ]),
          _createElementVNode("div", _hoisted_25, [
            (_ctx.editMode || !_ctx.currentQuest.complete)
              ? (_openBlock(), _createBlock(_component_cancel_confirm_button, {
                  key: 0,
                  text: _ctx.editMode ? 'Save' : 'Claim',
                  invert: "",
                  onPressed: _ctx.processClaim
                }, null, 8, ["text", "onPressed"]))
              : _createCommentVNode("", true),
            (_ctx.currentQuest.id && !_ctx.currentQuest.id.startsWith('root-'))
              ? (_openBlock(), _createBlock(_component_cancel_confirm_button, {
                  key: 1,
                  text: "Delete",
                  invert: "",
                  onPressed: _ctx.deleteCurrentQuest
                }, null, 8, ["onPressed"]))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ], 34)
  ], 64))
}